@use '@/styles/mixins' as *;

.backdrop {
  position: fixed;
  inset: 0;
  z-index: $z-sheet;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: var(--scrim);
  animation: fade $dur $ease-out;

  @include tablet {
    align-items: center;
    padding: $space-5;
  }
}

.panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100dvh - env(safe-area-inset-top) - #{$space-5});
  background: var(--bg);
  border-radius: $radius-xl $radius-xl 0 0;
  box-shadow: var(--shadow-3);
  padding-bottom: env(safe-area-inset-bottom);
  animation: rise $dur-slow $ease-out;
  transition: transform $dur $ease-out;
  outline: none;
  will-change: transform;

  @include tablet {
    max-width: 540px;
    max-height: min(88dvh, 860px);
    border-radius: $radius-xl;
    padding-bottom: 0;
    animation: pop $dur $ease-out;
  }
}

.wide {
  @include tablet {
    max-width: 760px;
  }
}

.handleArea {
  flex: 0 0 auto;
  touch-action: none;
  cursor: grab;

  @include tablet {
    touch-action: auto;
    cursor: auto;
  }
}

.grip {
  width: 40px;
  height: 5px;
  border-radius: 99px;
  background: var(--surface-3);
  margin: 10px auto 0;

  @include tablet {
    display: none;
  }
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: $space-3;
  padding: $space-3 $space-4 $space-3 $space-5;

  @include tablet {
    padding-top: $space-5;
  }
}

.titles {
  min-width: 0;
  padding-top: 6px;

  h2 {
    font-size: 1.4rem;
    line-height: 1.2;
  }

  p {
    margin-top: 4px;
    color: var(--text-2);
    font-size: 0.95rem;
    line-height: 1.4;
  }
}

.close {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  margin-top: 2px;
  border-radius: 50%;
  background: var(--surface-2);
  color: var(--text-2);
  @include pressable;
  @include focus-ring;
}

.body {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: $space-2 $space-4 $space-5;

  @include tablet {
    padding: $space-2 $space-5 $space-5;
  }
}

.footer {
  display: flex;
  gap: $space-3;
  justify-content: flex-end;
  padding: $space-3 $space-4 $space-4;

  > * {
    flex: 1;
  }

  @include tablet {
    padding: $space-3 $space-5 $space-5;
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@keyframes rise {
  from {
    transform: translateY(100%);
  }
}

@keyframes pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
}
